import * as React from "react";
import { Alert } from "react-bootstrap";
import { cn, Component, I18NString } from "../libs/helpers/Utils";
import { ISectionSchema } from "./Section";

interface SidebarItem {
	id: string;
	title: I18NString;
	percent: number;
	children: Array<SidebarItem>;
	parent: string;
}

interface State {
	isToggledMenu?: boolean;
	accordions?: { [key: string]: boolean };
}

interface Props {
	items: Array<SidebarItem>;
	onSelected: (id: string) => void;
	isClose: boolean;
	value?: string;
	// TODO: unused var
	status: number;
}

interface PercentProps {
	percent: number;
}

const Percent = ({ percent }: PercentProps): JSX.Element => (
	<span
		className={cn("label pull-right", {
			"label-secondary": percent === 0 || percent < 0,
			"label-danger": percent > 0 && percent <= 45,
			"label-warning": percent > 45 && percent < 100,
			"label-success": percent >= 100,
		})}
	>
		{!!percent || percent === 0 ? `${percent < 0 ? 0 : percent}%` : ""}
	</span>
);

const buildTree = (input: Array<any>, parentId?: string) => {
	if (!input) {
		return [];
	}

	const cleanInput = parentId
		? input.filter((section) => section.parent === parentId)
		: input.filter((section) => !section.parent);

	const tree = cleanInput.reduce((arr, section) => {
		if (!section.children || section.children.length === 0) {
			arr.push({
				current: section,
				children: [],
			});
		} else {
			arr.push({
				current: section,
				children: [...buildTree(input, section.id)],
			});
		}

		return arr;
	}, []);

	return tree;
};

class Sidebar extends Component<Props, any> {
	state: State = {
		isToggledMenu: false,
	};

	componentDidMount() {
		const accordions = this.props.items.reduce((obj, item) => {
			if (item?.children?.length > 0) {
				return { ...obj, [item.id]: false };
			}

			return obj;
		}, {});

		this.setState({ accordions });
	}

	toggleMenu = () => {
		this.setState(({ isToggledMenu }) => ({ isToggledMenu: !isToggledMenu }));
	};

	toggle = (id: string) => (event: React.MouseEvent<HTMLAnchorElement>) => {
		event.stopPropagation();
		event.preventDefault();
		this.setState(({ accordions }) => ({ accordions: { ...accordions, [id]: !accordions[id] } }));
	};

	onClick = (id: string) => (event: React.MouseEvent<HTMLAnchorElement>) => {
		event.stopPropagation();
		event.preventDefault();

		this.toggleMenu();
		this.props.onSelected(id);
		document.getElementsByClassName("reportbox-content-viewport")[0].scrollTo(0, 0);
	};

	createItemMenu = (sections: ISectionSchema) => {
		const recursiveSections = (sections, count = 0) =>
			sections.filter(section => !section.current.hidden).map((section) => {
				const { current, children } = section;
				const hasChildren = !!children?.length;
				const hasParent = !!current?.parent;
				const isShown = this.state?.accordions?.[current.parent];

				return (
					<>
						{(!hasParent || isShown) && (
							<li key={current.id} className={cn({ active: this.props.value === current.id })}>
								<a onClick={!hasChildren ? this.onClick(current.id) : this.toggle(current.id)}>
									<span className="nav-pills-label" style={count > 0 ? { marginLeft: `${count * 15}px` } : null}>
										{current.id === "ReadyPDF" && <span className="fa fa-file-pdf-o" />}
										{hasChildren ? `${this.tr(current.title)} +` : this.tr(current.title)}
									</span>
									<Percent percent={current.percent} />
								</a>
							</li>
						)}

						{hasChildren && recursiveSections(children, count + 1)}
					</>
				);
			});

		return recursiveSections(sections);
	};

	render() {
		const { isToggledMenu } = this.state;
		const { isClose } = this.props;
		const tree = buildTree(this.props.items);

		return (
			<ul
				className={cn("nav nav-pills nav-stacked", {
					active: isToggledMenu,
				})}
			>
				{tree && this.createItemMenu(tree)}
				{isClose && (
					<li>
						{/*// @ts-ignore*/}
						<Alert bsStyle="danger">
							<strong>Версия заявки устарела</strong>
							<br />
							Ваша версия Черновика данной заявки устарела. Необходимо создать новую заявку по данной программе, не
							копируя текущую.
						</Alert>
					</li>
				)}
			</ul>
		);
	}
}

export default Sidebar;
